import axios from '@axios'

export default {
    namespaced: true,
    state: {
        solicitudes: [],
        solicitud: {},
        ultimoCodigo: '',
    },
    getters: {
        getSolicitudes(state) {
            return state.solicitudes
        },
        getSolicitud(state) {
            return state.solicitud
        },
        getUltimoCodigo(state) {
            return state.ultimoCodigo
        },
    },
    mutations: {
        setSolicitudes(state, solicitudes) {
            state.solicitudes = solicitudes
        },
        setSolicitud(state, solicitud) {
            state.solicitud = solicitud
        },
        setUltimoCodigo(state, ultimoCodigo) {
            state.ultimoCodigo = ultimoCodigo
        },
    },
    actions: {
        /* ULTIMO CODIGO */
        fetchUltimoCodigo({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/solicitudes/ultimo-codigo', { params })
                    .then(response => {
                        commit('setUltimoCodigo', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* AREAS */
        fetchAreas() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/solicitudes/areas')
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* LINEAS E ITEMS */
        fetchLineas(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/solicitudes/lineas', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchItems(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/solicitudes/items', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* SOLICITUDES */
        fetchSolicitudes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/solicitudes', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSolicitudes', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        storeSolicitud(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/solicitudes', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        updateSolicitud(_, { Id, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/solicitudes/${Id}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
